import { LogOut, PanelLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function titleFromPath(pathname) {
  if (pathname === '/dashboard') return 'Overview';
  if (/\/pages\/\d+\/sections\/\d+$/.test(pathname)) return 'Section Editor';
  if (pathname.startsWith('/dashboard/pages') && pathname.endsWith('/sections')) {
    return 'Sections';
  }
  if (pathname.startsWith('/dashboard/menus')) return 'Menus';
  if (pathname.startsWith('/dashboard/pages')) return 'Pages';
  if (pathname.startsWith('/dashboard/sections')) return 'Section Editor';
  if (pathname.startsWith('/dashboard/media')) return 'Media Manager';
  if (pathname.startsWith('/dashboard/content')) return 'Dynamic Content';
  if (pathname.startsWith('/dashboard/contacts')) return 'Contacts';
  if (pathname.startsWith('/dashboard/services')) return 'Services';
  if (pathname.startsWith('/dashboard/projects')) return 'Projects';
  if (pathname.startsWith('/dashboard/blogs')) return 'Blogs';
  return 'Dashboard';
}

export default function Topbar({ pathname, onToggleSidebar }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const title = titleFromPath(pathname);

  return (
    <header className="sticky top-0 z-10 flex h-16 items-center justify-between border-b border-white/25 bg-[#191B1C]/95 px-4 backdrop-blur sm:px-6 lg:px-8">
      <div className="flex items-center gap-3">
        {onToggleSidebar ? (
          <button
            type="button"
            onClick={onToggleSidebar}
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/25 text-white/80 transition hover:bg-white/10 hover:text-white lg:hidden"
            aria-label="Toggle sidebar"
          >
            <PanelLeft className="h-5 w-5" aria-hidden />
          </button>
        ) : null}
        <div>
        <h1 className="text-lg font-semibold text-white">{title}</h1>
        {user?.email || user?.userName || user?.username ? (
          <p className="text-sm text-white/65">
            {user.email ?? user.userName ?? user.username}
          </p>
        ) : null}
        </div>
      </div>
      <button
        type="button"
        onClick={() => {
          logout();
          navigate('/login', { replace: true });
        }}
        className="dash-btn-outline inline-flex items-center gap-2 rounded-xl border px-4 py-2 text-sm font-medium shadow-sm transition"
      >
        <LogOut className="h-4 w-4" aria-hidden />
        Log out
      </button>
    </header>
  );
}
